const Star = ({ ...props }) => {
    return (
        <svg
            width="20"
            height="18"
            viewBox="0 0 27 25"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fill="#696158"
                d="M21.2036 8.78907C22.8223 8.91661 25.4585 9.21724 25.5972 9.59986C25.921 10.4926 19.0946 14.911 19.0946 14.911C19.0946 14.911 22.0638 22.5817 21.0093 23.5109C20.1398 24.2579 13.5817 19.1016 13.5817 19.1016C13.5817 19.1016 6.57038 23.7477 6.15414 23.5018C4.94241 22.773 8.06885 14.9019 8.06885 14.9019C8.06885 14.9019 -0.607465 10.2922 1.56624 9.59075C4.50767 8.6342 9.81706 8.67975 9.81706 8.67975C9.81706 8.67975 12.1018 1 13.5817 1C14.7472 1 17.3464 8.68886 17.3464 8.68886C17.3464 8.68886 19.2334 8.68886 21.2036 8.78907Z"
                stroke="#696158"
            />
        </svg>
    )
}

export default Star
